import { render, staticRenderFns } from "./PayForTicket.vue?vue&type=template&id=89b05dc0&scoped=true"
import script from "./PayForTicket.vue?vue&type=script&lang=js"
export * from "./PayForTicket.vue?vue&type=script&lang=js"
import style0 from "./PayForTicket.vue?vue&type=style&index=0&id=89b05dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b05dc0",
  null
  
)

export default component.exports